import { State } from '@meraki-internal/state';
import { INoteResponse } from './NotesClient.ts';
import { IWithNotesLink, NotesModel } from './NotesModel.ts';

export class EditNoteViewModel<T extends IWithNotesLink, R extends INoteResponse> extends State<Record<string, never>> {
    constructor(private note: R, private notesVM: NotesModel<T, R>){
        super({ });
    }

    isValid = () => this.notesVM.getValidator().isValid(this.getNote());

    getNote = () => {
        return this.note;
    };

    setNote = (note: R) => {
        // TODO: we're assuming we're dirty, better would be to diff
        this.isDirty = true;

        this.note = note;
        this.setState({ });
    };

    canSave = () => {
        return !this.isSaving && this.isValid() && this.isDirty;
    };

    isDirty = false;
    isSaving = false;

    save = async () => {
        this.isSaving = true;
        this.setState({ });

        try {
            return await this.notesVM.putNote(this.getNote());
        }
        finally {
            this.isSaving = false;
            this.setState({ });
        }

    };

    delete = async () => {
        await this.notesVM.deleteNote(this.getNote());
    };
}
